import { COURSE_TYPE_TRAINER } from '@/constants/types';
import draft from './draft';

export const DEFAULT_DRAFT = {
    id: 0,
    type: COURSE_TYPE_TRAINER,
    date: null,
    weekdays: [],
    start_time: null,
    end_time: null,
    programs: [],
    program_options: [],
    event: null,
    comment: null,
    comment_publicly: true,
    draft: true,
};

export default {
    course: null,
    next: null,
    earlier_courses: [],
    earlier_boundary: {
        date: null,
        time: null,
    },
    earlier_has_more: true,
    later_courses: [],
    later_boundary: {
        date: null,
        time: null,
    },
    later_has_more: true,
    draft: draft.get() || DEFAULT_DRAFT,
    created: null,
};



// WEBPACK FOOTER //
// ./src/store/course/state.js